export class GMention {
    constructor(
        public code?: string,
        public libelle?: string,
        public valide?: boolean,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/g-mention.model.ts